import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';

const SquareIconButton = ({ children, className, vert, ...props }) => {
	const useStyles = makeStyles(() => ({
		squareIconButtonRoot: {
			borderRadius: '0px',
		},
	}));
	const classes = useStyles();
	const direction = vert ? classes.squareIconButtonColumn : '';
	return (
		<IconButton
			sx={props.muistyle}
			className={clsx(classes.squareIconButtonRoot, className, direction)}
			{...props}
			size='large'>
			{children}
		</IconButton>
	);
};

export default SquareIconButton;
